/* istanbul ignore file */
import {SiteStore} from '@wix/wixstores-client-storefront-sdk';
import {Topology} from '@wix/wixstores-client-core';

export abstract class ApiBase {
  protected readonly siteStore: SiteStore;

  constructor({siteStore}: {siteStore: SiteStore}) {
    this.siteStore = siteStore;
  }

  protected get /* istanbul ignore next */ endpoint() {
    /* istanbul ignore next */
    return this.siteStore.resolveAbsoluteUrl(`/${Topology.READ_WRITE_GRAPHQL_URL}`);
  }
}
